"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var AlertCheckmark = (0, _createIcon["default"])({
  path: 'M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5ZM8.07273 10.9419L10.6392 13.6656L15.9424 8.28829C16.3142 7.91127 16.9255 7.90296 17.3077 8.26973C17.6899 8.63649 17.6984 9.23945 17.3266 9.61647L11.3153 15.7117C10.9302 16.1022 10.2921 16.0951 9.91605 15.696L6.65831 12.2387C6.29528 11.8534 6.31762 11.2508 6.7082 10.8927C7.09878 10.5346 7.70971 10.5567 8.07273 10.9419Z',
  // prettier-ignore
  viewBox: '24 24',
  displayName: 'AlertCheckmark',
  icon: 'alertCheckmark'
});
var _default = exports["default"] = AlertCheckmark;